import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { API_BASE_URL } from "../../Config/Config";
import "../../Config/loader.css";
import Pagination from "../../Config/Pagination";
import { useLocation } from "react-router-dom";

export default function TodayTransactions() {
  const location = useLocation();
  const { reportId } = location.state || {};

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [MisUserDetails, SetUserDetails] = useState([]);
  const [storesdata, setStoresData] = useState([]);
  const [selectedStore, setSelectedStore] = useState("0");
  const [salesdata, SetsalesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  // Today’s date (fixed for this report)
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");

  // Load user session
  useEffect(() => {
    const MisUserDetailsSession =
      JSON.parse(
        sessionStorage.getItem("MisUserDetails") ||
          localStorage.getItem("MisUserDetails"),
      ) || {};
    SetUserDetails(MisUserDetailsSession);
  }, []);

  useEffect(() => {
    if (MisUserDetails?.OrgId) {
      const fetchStoresData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_URL}Settings/getUserStores?OrgId=${MisUserDetails.OrgId}&UserId=${MisUserDetails.UserId}`,
          );
          if (response.ok) {
            const data = await response.json();
            if (data?.ResultData) {
              setStoresData(data.ResultData);
            }
          }
        } catch (error) {
          console.error("Error fetching stores:", error);
        }
      };
      fetchStoresData();
    }
  }, [MisUserDetails]);

  useEffect(() => {
    const today = getFormattedDate(new Date());
    setSelectedFromDate(today);
    setSelectedToDate(today);
  }, []);

  const fetchTodayTransactions = () => {
    if (!MisUserDetails?.OrgId || !reportId) return;

    setLoading(true);

    const requestData = {
      OrgId: MisUserDetails.OrgId,
      UserId: MisUserDetails.UserId,
      ReportId: reportId,
      ReportCriteria: {
        FromDate: selectedFromDate,
        ToDate: selectedToDate,
        ProductId: 0,
        SupplierId: 0,
        UserId: 0,
        LoginUserId: MisUserDetails.UserId,
        StoreId: selectedStore || 0,
        CustomerId: 0,
        CategoryId: 0,
        City: 0,
        Status: 0,
      },
    };

    fetch(`${API_BASE_URL}report/getreport`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Today Transactions API Response:", data);
        if (data && data.data) {
          SetsalesData(data.data);
        } else {
          SetsalesData([]);
          console.warn("No data returned from report API");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching today transactions:", error);
        SetsalesData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedFromDate && selectedToDate && MisUserDetails?.OrgId) {
      fetchTodayTransactions();
    }
  }, [selectedFromDate, selectedToDate, MisUserDetails, reportId,selectedStore]);

  let filteredItems = salesdata.filter(
    (item) =>
      (item.OrderNo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.OrderDate || "").toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleStoreChange = (event) => {
    setSelectedStore(event.target.value);
  };

  const handleSearch = () => {
    fetchTodayTransactions();
  };

  return (
    <Base>
      <div>
        <div className="mb-2">
          <div className="page-title mb-2">
            <h4>Today Transactions</h4>
           
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="search-bar col-10">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Search Order No"
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <button
              onClick={() => setIsFilterVisible(!isFilterVisible)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <i
                className="fa fa-filter"
                style={{ fontSize: "24px", color: "#333" }}
              ></i>
            </button>
          </div>
        </div>

        {isFilterVisible && (
          <div className="row g-3 mb-3">
            <div className="col-12 col-lg-4">
              <label className="form-label">Store</label>
              <select
                className="form-select"
                value={selectedStore}
                onChange={handleStoreChange}
              >
                <option value="0">-- All Stores --</option>
                {storesdata.map((store) => (
                  <option key={store.StoreId} value={store.StoreId}>
                    {store.Name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 col-lg-3" style={{ marginTop: "32px" }}>
              <button
                className="btn btn-secondary w-100"
                onClick={handleSearch}
              >
                <i className="fa-solid fa-magnifying-glass"></i> Search
              </button>
            </div>
          </div>
        )}

        <div className="card-container mb-4">
          {loading ? (
            <div className="text-center my-5">
              <div className="containers m-auto d-flex justify-content-center align-items-center">
                <div className="dot bg-primary"></div>
                <div className="dot bg-secondary"></div>
                <div className="dot bg-success"></div>
                <div className="dot bg-danger"></div>
                <div className="dot bg-warning"></div>
                <div className="dot bg-info"></div>
              </div>
              <p>Loading Today Transactions...</p>
            </div>
          ) : (
            <div className="row">
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <div key={index} className="col-md-6 col-lg-4 mb-1">
                    <div
                      className="store-card card shadow-sm mb-1"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "6px",
                      }}
                    >
                      <div className="card-body p-2">
                        <div className="card-details">
                          <div className="row" style={{ color: "#6c757d" }}>
                            {/* Order No */}
                            <div className="col-6 p-1">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-receipt me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                </strong>{" "}
                                {item.OrderNo || "N/A"}
                              </span>
                            </div>

                            {/* Order Date */}
                            <div className="col-3 p-1">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-clock me-2"
                                    style={{ color: "#007bff" }}
                                  ></i>
                                </strong>{" "}
                              {item.OrderDate 
          ? item.OrderDate.split(" ")[1]?.slice(0, 5) || "N/A" 
          : "N/A"}
                              </span>
                            </div>
                            {/* <div className="col-8 p-1 text-end"></div> */}
                            <div className="col-3 p-1 text-end">
                              <span>
                                <strong>
                                  <i
                                    className="fa-solid fa-money-bill me-2 d-none"
                                    style={{ color: "#28a745" }}
                                  ></i>{" "}
                                </strong>
                                <strong>₹ </strong>
                                {item.BillAmount !== undefined
                                  ? item.BillAmount
                                  : item.OrderAmount !== undefined
                                    ? item.OrderAmount
                                    : "0"}
                                /-
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <h5>No transactions found for today</h5>
                </div>
              )}
            </div>
          )}

          {/* Pagination */}
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
    </Base>
  );
}
